var _defs, _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAfter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1456.49 1456.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fed631;}.cls-2{fill:#1a1a1a;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 149.67,
    y: 149.67,
    width: 1157.15,
    height: 1157.15,
    rx: 133.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M761,981.17q-96.87-255-194.2-509.84c-1.7-4.44-9.28-9.09-14.33-9.35-21-1-42.22.36-63.27-.74-12.38-.65-17.84,3.59-22.22,15.18Q393.26,671.8,318.46,866.78c-15.16,39.74-30.34,79.47-46.16,120.92,34.13,0,66.41.33,98.66-.49,3.55-.08,8.5-6.18,10.15-10.5q20.58-54,39.94-108.46c3-8.56,7.22-11.91,16.56-11.84q79.51.65,159,0c9.9-.09,14.5,3.29,17.8,12.51q19.46,54.4,40.53,108.24c1.73,4.42,7.85,10,12.07,10.09,31.34.86,62.72.47,95.36.47C761.65,984.1,761.54,982.55,761,981.17ZM443.13,783.72C468,715.63,492.35,648.8,518.24,577.85l72.44,205.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1181,824.91c16.38-94.62-29.11-195.6-140.85-224.33-110.24-28.35-219.93,19.61-254.42,135.48C754,842.68,809.23,952,913.45,984.44c105.61,32.88,213.72-12,247.25-91.17q-34.08-9.67-68-19.25c-4.87-1.38-9.85-2.37-14.49-3.46-37.29,47.68-84.94,63.62-132.48,44.71-34.09-13.57-63.28-56.49-60.21-90.36ZM882.14,760c4.37-56,47.75-96.71,100.45-95.35,54.41,1.4,95.47,40.81,98.31,95.35Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfter);
export default __webpack_public_path__ + "static/media/after.4bc2443ad98b19735aa9a17138ab3c60.svg";
export { ForwardRef as ReactComponent };